import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { useCall } from '../context/CallContext';

export default function ActiveCallsList() {
  const { activeCalls } = useCall();

  if (activeCalls.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Phone className="h-5 w-5 text-green-500 mr-2" />
        Aktiva samtal
      </h2>
      <div className="space-y-4">
        {activeCalls.map((call) => (
          <div key={call.id} className="border-l-4 border-green-500 bg-green-50 p-4 rounded-r-lg">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-medium text-gray-900">{call.phoneNumber}</p>
                <p className="text-sm text-gray-500">Startade: {call.time}</p>
              </div>
              <div className="flex items-center space-x-2">
                <MessageSquare className="h-5 w-5 text-green-600" />
                <span className="text-sm text-green-600">Live</span>
              </div>
            </div>
            {call.transcript && (
              <div className="mt-2">
                <p className="text-sm text-gray-600 italic">{call.transcript}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}